(() => {
  const SELECTOR = "[data-rs10-prep]";
  const OPEN_CLASS = "x-rs10-modal-open";

  function getFocusable(container) {
    return Array.from(
      container.querySelectorAll(
        'a[href], button:not([disabled]), textarea, input, select, video[controls], iframe, [tabindex]:not([tabindex="-1"])'
      )
    ).filter((element) => element.offsetParent !== null);
  }

  function pauseMedia(modal) {
    modal.querySelectorAll("video").forEach((video) => {
      video.pause();
      video.currentTime = 0;
    });

    modal.querySelectorAll("iframe[data-src]").forEach((iframe) => {
      iframe.removeAttribute("src");
    });
  }

  function initSection(section) {
    if (section.dataset.rs10Initialized === "true") return;
    section.dataset.rs10Initialized = "true";

    const openButtons = section.querySelectorAll("[data-rs10-modal-open]");
    const modal = section.querySelector("[data-rs10-modal]");
    if (!openButtons.length || !modal) return;

    const closeButtons = modal.querySelectorAll("[data-rs10-modal-close]");
    let returnFocusTo = null;

    const openModal = (trigger) => {
      returnFocusTo = trigger;
      modal.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add(OPEN_CLASS);

      modal.querySelectorAll("iframe[data-src]").forEach((iframe) => {
        if (!iframe.getAttribute("src")) {
          iframe.setAttribute("src", iframe.dataset.src);
        }
      });

      const video = modal.querySelector("video");
      if (video) {
        video.currentTime = 0;
        video.play().catch(() => {});
      }

      const focusable = getFocusable(modal);
      (focusable[0] || modal).focus();
    };

    const closeModal = () => {
      modal.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove(OPEN_CLASS);
      pauseMedia(modal);

      if (returnFocusTo && typeof returnFocusTo.focus === "function") {
        returnFocusTo.focus();
      }
    };

    openButtons.forEach((button) => {
      button.addEventListener("click", () => openModal(button));
    });

    closeButtons.forEach((button) => {
      button.addEventListener("click", closeModal);
    });

    modal.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        closeModal();
        return;
      }

      if (event.key !== "Tab") return;

      const focusable = getFocusable(modal);
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function initAll(root = document) {
    root.querySelectorAll(SELECTOR).forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll());
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
})();
